'use client';

import { useEffect, useState } from 'react';
import useShowPricing from '@/lib/hooks/useShowPricing';

const CurrencyPrice = ({ price, usPrice, justSign = false }: { price?: string; usPrice?: string; justSign?: boolean }) => {
    const { showPricing, loading } = useShowPricing();
    const [currency, setCurrency] = useState('$');
    const [priceToDisplay, setPriceToDisplay] = useState(price);
    const [negotiationMessage, setNegotiationMessage] = useState('To be negotiated.');

    useEffect(() => {
        setCurrency('$');
        setPriceToDisplay(price);
    }, [price]);

    useEffect(() => {
        if (!showPricing) {
            fetch('/api/admin/settings')
                .then(res => res.json())
                .then(data => {
                    setNegotiationMessage(data.negotiationMessage || 'To be negotiated.');
                });
        }
    }, [showPricing]);

    if (loading) return <span>...</span>;
    if (!showPricing) {
        return (
            <span className="text-lg font-bold text-gray-900">
                {negotiationMessage}
            </span>
        );
    }

    return (
        <span className="text-lg font-bold text-gray-900">
            {currency} {justSign ? '' : priceToDisplay}
        </span>
    );
};

export default CurrencyPrice;
